import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { seoService } from '../services/seoService';

const pageKeyMap: Record<string, string> = {
  '/': 'home',
  '/nosotros': 'nosotros',
  '/servicios/membresias': 'membresias',
  '/servicios/fullday': 'fullday',
  '/servicios/eventos': 'eventos',
  '/contactanos': 'contacto',
  '/sedes': 'sedes'
};

export default function DynamicSEO() {
  const location = useLocation();

  useEffect(() => {
    const updateSEO = async () => {
      const pageKey = pageKeyMap[location.pathname];
      if (!pageKey) return;

      try {
        const seo = await seoService.getActiveSeo(pageKey);
        if (!seo) return;

        document.title = seo.title;
        
        const updateMeta = (name: string, content: string) => {
          let meta = document.querySelector(`meta[name="${name}"]`);
          if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', name);
            document.head.appendChild(meta);
          }
          meta.setAttribute('content', content);
        };

        const updateProperty = (property: string, content: string) => {
          let meta = document.querySelector(`meta[property="${property}"]`);
          if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('property', property);
            document.head.appendChild(meta);
          }
          meta.setAttribute('content', content);
        };

        if (seo.description) updateMeta('description', seo.description);
        if (seo.keywords) updateMeta('keywords', seo.keywords);
        if (seo.og_title) updateProperty('og:title', seo.og_title);
        if (seo.og_description) updateProperty('og:description', seo.og_description);
        if (seo.og_image) updateProperty('og:image', seo.og_image);
      } catch (error) {
        console.error('Error loading SEO:', error);
      }
    };

    updateSEO();
  }, [location.pathname]);

  return null;
}
